"use client";

import { usePortfolio } from "@/hooks/usePortfolio";
import { useAuth } from "@/hooks/useAuth";
import clsx from "clsx";

export const StrategiesHeader = () => {
  const { isAuthenticated } = useAuth();
  const { portfolio, isLoading } = usePortfolio();

  // Show portfolio summary only if authenticated and has allocations
  const showPortfolioSummary =
    isAuthenticated && portfolio && portfolio.allocationCount > 0 && !isLoading;

  return (
    <div className="mb-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white">Strategies</h1>
          <p className="mt-1 text-sm text-slate-400">
            Automated trading strategies. Allocate capital and earn returns.
          </p>
        </div>

        {showPortfolioSummary && (
          <div className="flex gap-6 rounded-xl border border-slate-200/60 bg-white/5 px-5 py-3">
            <div>
              <p className="text-xs text-slate-500">Total Allocated</p>
              <p className="text-lg font-semibold text-white">
                ${portfolio.totalAllocated.toLocaleString()}
              </p>
            </div>
            <div>
              <p className="text-xs text-slate-500">Unrealized P&L</p>
              <p
                className={clsx(
                  "text-lg font-semibold",
                  portfolio.totalUnrealizedPnl >= 0 ? "text-emerald-400" : "text-rose-400"
                )}
              >
                {portfolio.totalUnrealizedPnl >= 0 ? "+" : ""}$
                {portfolio.totalUnrealizedPnl.toLocaleString()}
                <span className="ml-1 text-xs">
                  ({portfolio.totalUnrealizedPnlPercent >= 0 ? "+" : ""}
                  {portfolio.totalUnrealizedPnlPercent.toFixed(2)}%)
                </span>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
